import React from 'react'
import CaroselRow from '../components/caroselRow'
import Footer from '../components/footer'
import Movie from '../components/movie'

const Home = () => {

  return (
    <>
      <Movie></Movie>
      <CaroselRow></CaroselRow>
      <Footer></Footer>
    </>
  )
}


export default Home